// src/components/artsPersonComponent/formWoman.js
import person from "../../assets/imgs/persons/formWoman.png";
import { useTheme } from "@mui/material";

function SvgText({ x, y, fill, fontSize, fontWeight, text, highlightColor }) {
	// Se for string simples, só divide por \n
	if (typeof text === "string") {
		const lines = text.split("\n"); // Corrigido de "\\n" para "\n"
		return (
			<text x={x} y={y} fill={fill} fontSize={fontSize} fontWeight={fontWeight}>
				{lines.map((line, i) => (
					<tspan key={i} x={x} dy={i === 0 ? 0 : "1.4em"}>
						{line}
					</tspan>
				))}
			</text>
		);
	}

	// Se for objeto { before, highlight, after }, renderiza com destaque
	const { before, highlight, after } = text;
	const beforeLines = before.split("\n"); // Corrigido de "\\n" para "\n"
	const afterLines = after ? after.split("\n") : []; // Corrigido de "\\n" para "\n"

	return (
		<text x={x} y={y} fill={fill} fontSize={fontSize} fontWeight={fontWeight}>
			{beforeLines.map((line, i) => (
				<tspan key={`before-${i}`} x={x} dy={i === 0 ? 0 : "1.4em"}>
					{line}
					{i === beforeLines.length - 1 && (
						<tspan fill={highlightColor}>{highlight}</tspan>
					)}
					{i === beforeLines.length - 1 && afterLines[0]}
				</tspan>
			))}
			{afterLines.slice(1).map((line, i) => (
				<tspan key={`after-${i}`} x={x} dy="1.4em">
					{line}
				</tspan>
			))}
		</text>
	);
}

export default function FormWoman({ mainFill, mainText, subText }) {
	const theme = useTheme();
	return (
		<div style={{ width: "100%", maxWidth: "700px", margin: "0 auto" }}>
			<svg
				width="661"
				height="604"
				viewBox="0 0 661 604"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				style={{ width: "100%", height: "auto", display: "block" }}
			>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M403.578 473.219C473.797 459.78 564.956 500.012 607.39 440.565C650.411 380.298 617.282 289.438 584.593 219.637C556.393 159.42 503.776 117.379 444.572 92.8932C392.547 71.3765 339.538 86.3812 285.411 95.8989C218.689 107.631 140.627 98.6792 98.8485 153.686C52.2254 215.07 38.61 306.602 68.7227 381.194C97.4817 452.433 172.031 490.883 242.83 510.34C298.923 525.756 347.405 483.971 403.578 473.219Z"
					fill={mainFill}
				/>
				<rect
					x="329.996"
					y="143"
					width="330"
					height="330"
					fill="url(#pattern0_1331_3992)"
				/>
				<SvgText
					x={120}
					y={200}
					fill="#fff"
					fontSize={24}
					fontWeight={500}
					text={mainText}
					highlightColor={theme.palette.primary.main}
				/>
				<SvgText
					x={120}
					y={270}
					fill="#fff"
					fontSize={18}
					fontWeight={400}
					text={subText}
				/>
				<defs>
					<pattern
						id="pattern0_1331_3992"
						patternContentUnits="objectBoundingBox"
						width="1"
						height="1"
					>
						<use xlinkHref="#image0_1331_3992" transform="scale(0.0030303)" />
					</pattern>
					<image
						id="image0_1331_3992"
						width="330"
						height="330"
						preserveAspectRatio="none"
						href={person}
					/>
				</defs>
			</svg>
		</div>
	);
}